import type { ElementType, ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import type { TableHeaderProps } from "./Table.types";

const TableHeaderComponent = (props: TableHeaderProps): ReactElement => {
  const { as, className, style, children } = props;
  const Component = (as || "thead") as ElementType;
  return (
    <Component className={className} style={style}>
      {children}
    </Component>
  );
};

export const TableHeader = styled(TableHeaderComponent)``;
